var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "header-section" }, [
    _c(
      "div",
      {
        staticClass: "section-background",
        style: { "background-color": _vm.color }
      },
      [
        _c("div", { staticClass: "section-background__effects" }),
        _vm._v(" "),
        _c("div", { staticClass: "section-background__foreground" }, [
          _c("p", { staticClass: "header-section__timestamp" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.setPublishDate) } })
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "header-section__title" }, [
            _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }